var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhale = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#whale_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.97 14.52c-.141.622-.924.345-1.369.219-.378-.108-1.774-.28-1.908-.493-.242-.382.643-.696 1.393-.818.772-.126 2.076.254 1.884 1.092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8D2F5",
    d: "M9.881 23.496c-3.718-.077-6.904-2.09-8.226-5.057a7 7 0 0 1-.295-.772c.835.274 2.892-2.65 6.146-1.976l.127.027c2.773.62 3.645 2.343 6.634 2.168.861.386.938.648 1.529 1.114.338.265 1.683 1.53 2.97.755.605-.337.636-1.344.412-2.305a6 6 0 0 0-.13-.463c2.83-1.249 4.573-4.51 4.627-7.71.28 6.608-4.543 14.412-13.794 14.219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B81F6",
    d: "M23.384 6.905c-.344-.864-.465-1.304-.344-2.341.092-.568-.466-5.039-1.717-3.87-.357.683-1.215 4.365-1.195 4.36-.332.22-2.658 1.601-2.845 1.945 1.201 1.14 2.958-.01 4.271.545.793.8.284 2.161-.442 2.804-.404.36-1.072.59-1.72.735a2.7 2.7 0 0 1-2.617-.828c-1.629-1.831-4.112-3-6.894-3-4.846 0-8.787 3.55-8.879 7.962L1 15.376c0 .796.126 1.565.36 2.292.835.274 2.892-2.65 6.146-1.976q.064.013.127.027c2.773.62 3.645 2.343 6.634 2.167.861.386.938.648 1.529 1.114.338.266 1.683 1.53 2.97.755.593-.356.633-1.348.412-2.304a6 6 0 0 0-.13-.463c2.83-1.25 4.573-4.51 4.627-7.71v-.002a8.4 8.4 0 0 0-.291-2.371m-16.691 7.34c-.242-.38.643-.694 1.392-.817.773-.126 2.077.253 1.885 1.092-.141.622-.924.345-1.369.219-.378-.108-1.774-.28-1.908-.494"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B81F6",
    d: "M9.97 14.52c-.141.622-.924.345-1.369.219-.378-.108-1.774-.28-1.908-.493-.242-.382.643-.696 1.393-.818.772-.126 2.076.254 1.884 1.092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.004,
    d: "M7.603 13.68a.958.958 0 1 0 1.916.002.958.958 0 0 0-1.916-.002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "whale_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 .5h22.686v23H1z"
  })))));
};
export default SvgWhale;